// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__zSTUo","image":"Header_image__3X7yt"};